/**
 * Legal content — Privacy Policy & Loyalty Terms
 * Fully translated to RU / KZ / EN.
 *
 * Content structure: each language exposes { effective, sections: [{ h2, blocks: [...] }] }
 * A "block" is either { p: string }, { ul: string[] } or { ulNested: string[] }.
 * Rendered by Legal.jsx.
 */

/* ────────────────────────────── PRIVACY POLICY ────────────────────────────── */
const privacy = {
  ru: {
    effective: "Дата вступления в силу: 1 января 2026 г.",
    sections: [
      {
        h2: "1. Общие положения",
        blocks: [
          { p: "Настоящая Политика конфиденциальности определяет порядок обработки персональных данных пользователей мобильного приложения и веб-сайта «Angiolini VIP Club» (далее — «Приложение»), оператором которого является ТОО «Italy Retail», БИН 220540021868, г. Алматы, ул. Аль-Фараби 5/2, ТЦ «Jurek Tau», -1 этаж (далее — «Оператор», «мы»)." },
          { p: "Политика разработана в соответствии с Законом Республики Казахстан от 21.05.2013 № 94-V «О персональных данных и их защите»." },
        ],
      },
      {
        h2: "2. Какие данные мы собираем",
        blocks: [
          { ul: [
            "**Номер телефона** — для регистрации и входа через SMS-код.",
            "**Имя** — для обращения к клиенту при общении и записях.",
            "**Дата рождения** — для начисления бонуса в день рождения.",
            "**Город** — для подбора ассортимента и точек доставки.",
            "**История покупок** — для расчёта VIP-уровня, кэшбэка и персональных предложений.",
            "**Записи на консультации и примерки** — для согласования времени с менеджером.",
            "**Реферальный код** и связь с пригласившим — для начисления реферальных бонусов.",
            "**Фотографии для виртуальной примерки** — обрабатываются ИИ-моделью и НЕ сохраняются на сервере после генерации результата (если иное явно не указано пользователем).",
            "**Push-токены устройств** (Firebase) — для отправки уведомлений о новинках и записях.",
            "**IP-адрес и тип устройства** — для безопасности и предотвращения злоупотреблений.",
          ]},
        ],
      },
      {
        h2: "2.1. Фотографии для AI-примерки (изображения с лицом)",
        blocks: [
          { p: "Виртуальная примерка работает только по вашей инициативе: вы сами выбираете фотографию и подтверждаете отдельное согласие перед её передачей. Без такого согласия фотография не передаётся и примерка не запускается." },
          { ul: [
            "**Что собирается.** Загруженная вами фотография (может содержать изображение лица) и сгенерированное изображение примерки.",
            "**Что НЕ выполняется.** Мы не производим распознавание лиц, не извлекаем лицевые ориентиры (face landmarks), не создаём и не храним биометрические шаблоны, не идентифицируем личность и не сопоставляем фотографии между пользователями. Фотография используется исключительно как визуальная основа для генерации изображения одежды.",
            "**Кому передаётся.** Фотография передаётся по защищённому каналу в Google Gemini API (модель gemini-3.1-flash-image-preview) через LLM-прокси Emergent Integrations — единственная цель передачи — сгенерировать изображение выбранной вещи на вас. Согласно условиям Gemini API для платных сервисов, передаваемые данные не используются для обучения моделей Google; Google может хранить запросы ограниченное время исключительно для контроля злоупотреблений и выполнения требований закона.",
            "**Где хранится.** Исходная фотография не сохраняется ни в нашей базе данных, ни в облачном хранилище: она обрабатывается в оперативной памяти сервера и исчезает сразу после генерации. В хранилище Cloudflare R2 сохраняется только результат примерки; в базе данных — техническая запись (идентификатор пользователя, товар, ссылка на результат, дата).",
            "**Сроки хранения.** Результат примерки хранится, пока вы сами его не удалите или пока не удалите аккаунт. Автоматического срока удаления результатов нет.",
            "**Удаление.** Любой результат можно удалить в разделе «AI-примерка» → история. При удалении аккаунта все ваши примерки удаляются вместе с файлами в облачном хранилище.",
            "**Использование.** Ваши фотографии и результаты не используются для обучения наших или сторонних моделей, для рекламы и для аналитики. В маркетинге они не публикуются.",
            "**Защита.** Доступ к результатам возможен только из вашей авторизованной сессии (cookie HttpOnly + проверка владельца на сервере); передача данных — по HTTPS; содержимое фотографий не записывается в журналы сервера (в логи попадают только размер файла и время обработки).",
          ]},
        ],
      },
      {
        h2: "3. Цели обработки",
        blocks: [
          { ul: [
            "Регистрация и аутентификация пользователя.",
            "Управление VIP-программой лояльности (начисление и списание бонусов, расчёт уровней).",
            "Запись на консультации, примерки и услуги ателье.",
            "Отправка уведомлений о новинках, поступлении заказов, скидках, акциях.",
            "Поздравление с днём рождения и предоставление подарочных бонусов.",
            "Внутренняя аналитика для улучшения работы Приложения и ассортимента.",
            "Защита от мошенничества и несанкционированного доступа.",
          ]},
        ],
      },
      {
        h2: "4. Правовое основание",
        blocks: [
          { p: "Обработка персональных данных производится с явного согласия пользователя, которое он даёт при первой регистрации в Приложении (отмечая соответствующую галочку перед получением SMS-кода). Согласие может быть отозвано в любой момент (см. п. 8)." },
        ],
      },
      {
        h2: "5. Срок хранения",
        blocks: [
          { p: "Данные хранятся в течение всего срока действия учётной записи пользователя и 5 лет после её удаления — для целей бухгалтерского и налогового учёта в соответствии с законодательством Республики Казахстан. По истечении этого срока данные удаляются или обезличиваются." },
        ],
      },
      {
        h2: "6. Передача третьим лицам",
        blocks: [
          { p: "Оператор НЕ передаёт персональные данные третьим лицам в коммерческих целях. Передача данных производится только следующим обработчикам, необходимым для функционирования Приложения:" },
          { ul: [
            "**SMSC.kz** (АО «СМС-Центр», Казахстан) — для доставки SMS-кодов подтверждения. Передаётся только номер телефона.",
            "**Google Firebase** (Google LLC, США) — для отправки push-уведомлений. Передаётся только обезличенный токен устройства.",
            "**Google Gemini** (Google LLC, США) — для виртуальной примерки (по запросу пользователя). Изображение обрабатывается и не сохраняется.",
            "**Государственные органы РК** — по официальному запросу в рамках законодательства.",
          ]},
        ],
      },
      {
        h2: "7. Меры защиты",
        blocks: [
          { ul: [
            "Шифрование данных при передаче (HTTPS/TLS).",
            "Хеширование паролей администраторов с использованием bcrypt.",
            "Двухфакторная аутентификация (TOTP) для административных аккаунтов.",
            "Ограничение доступа сотрудников по принципу минимальных привилегий.",
            "Журналирование действий администраторов (аудит-лог).",
            "Регулярное резервное копирование баз данных.",
          ]},
        ],
      },
      {
        h2: "8. Права пользователя",
        blocks: [
          { p: "В соответствии с Законом РК «О персональных данных и их защите» вы имеете право:" },
          { ul: [
            "Получить информацию о наличии у нас ваших персональных данных.",
            "Запросить исправление или дополнение данных, если они неточны или неполны.",
            "Запросить блокирование или удаление данных, если они обрабатываются с нарушением закона.",
            "Отозвать согласие на обработку персональных данных в любое время.",
            "Обратиться в Комитет по защите прав потребителей Министерства торговли и интеграции РК с жалобой.",
          ]},
          { p: "Для реализации этих прав направьте запрос на адрес [angiolinikz@gmail.com](mailto:angiolinikz@gmail.com) с темой «Персональные данные» — мы ответим в течение 15 рабочих дней." },
        ],
      },
      {
        h2: "9. Изменения политики",
        blocks: [
          { p: "Оператор оставляет за собой право периодически обновлять Политику конфиденциальности. О существенных изменениях пользователи будут уведомлены через push-уведомление или внутри Приложения не позднее, чем за 7 дней до вступления изменений в силу." },
        ],
      },
      {
        h2: "10. Контакты для обращений",
        blocks: [
          { p: "ТОО «Italy Retail»\nБИН 220540021868\nАдрес: г. Алматы, ул. Аль-Фараби 5/2, ТЦ «Jurek Tau», -1 этаж\nEmail: [angiolinikz@gmail.com](mailto:angiolinikz@gmail.com)\nТел.: [+7 701 801 77 55](tel:+77018017755)" },
        ],
      },
    ],
  },

  kz: {
    effective: "Күшіне ену күні: 2026 жылғы 1 қаңтар.",
    sections: [
      {
        h2: "1. Жалпы ережелер",
        blocks: [
          { p: "Осы Құпиялылық саясаты «Angiolini VIP Club» мобильді қосымшасы мен веб-сайтының (бұдан әрі — «Қосымша») пайдаланушыларының жеке деректерін өңдеу тәртібін айқындайды. Оператор — «Italy Retail» ЖШС, БСН 220540021868, Алматы қ., Әл-Фараби к-сі 5/2, «Jurek Tau» СО, -1 қабат (бұдан әрі — «Оператор», «біз»)." },
          { p: "Саясат Қазақстан Республикасының 2013 жылғы 21.05 № 94-V «Жеке деректер және оларды қорғау туралы» Заңына сәйкес әзірленді." },
        ],
      },
      {
        h2: "2. Біз қандай деректерді жинаймыз",
        blocks: [
          { ul: [
            "**Телефон нөмірі** — SMS-код арқылы тіркелу және кіру үшін.",
            "**Аты-жөні** — клиентке қатынасу және жазбалар үшін.",
            "**Туған күні** — туған күнде бонус есептеу үшін.",
            "**Қала** — ассортимент таңдау және жеткізу пункттері үшін.",
            "**Сатып алулар тарихы** — VIP-деңгей, кэшбэк және жеке ұсыныстарды есептеу үшін.",
            "**Кеңес алу мен өлшеу жазбалары** — менеджермен уақытты келісу үшін.",
            "**Рефералдық код** және шақырушымен байланыс — рефералдық бонустар есептеу үшін.",
            "**Виртуалды өлшеу үшін фотосуреттер** — ЖИ-модель өңдейді, нәтиже жасалғаннан кейін серверде САҚТАЛМАЙДЫ (пайдаланушы басқаша нақты көрсетпесе).",
            "**Құрылғылардың Push-токендері** (Firebase) — жаңалықтар мен жазбалар туралы хабарландырулар жіберу үшін.",
            "**IP-адрес пен құрылғы түрі** — қауіпсіздік және теріс пайдалануды болдырмау үшін.",
          ]},
        ],
      },
      {
        h2: "2.1. AI-киіп көру үшін фотосуреттер (бет бейнесі бар деректер)",
        blocks: [
          { p: "Виртуалды киіп көру тек сіздің бастамаңызбен жұмыс істейді: фотосуретті өзіңіз таңдайсыз және оны беру алдында бөлек келісім бересіз. Мұндай келісімсіз фотосурет берілмейді және киіп көру іске қосылмайды." },
          { ul: [
            "**Не жиналады.** Сіз жүктеген фотосурет (бет бейнесі болуы мүмкін) және жасалған киіп көру кескіні.",
            "**Не ЖАСАЛМАЙДЫ.** Біз бетті тануды жүргізбейміз, бет нүктелерін (face landmarks) шығармаймыз, биометриялық үлгілерді жасамаймыз және сақтамаймыз, жеке басты сәйкестендірмейміз және пайдаланушылар арасында фотосуреттерді салыстырмаймыз.",
            "**Кімге беріледі.** Фотосурет қорғалған арна арқылы Google Gemini API-ге (gemini-3.1-flash-image-preview моделі) Emergent Integrations LLM-проксиі арқылы беріледі. Берудің жалғыз мақсаты — таңдалған киімнің сіздегі кескінін жасау. Gemini API ақылы қызметтерінің шарттарына сәйкес берілген деректер Google модельдерін оқытуға пайдаланылмайды; Google сұрауларды теріс пайдалануды бақылау және заң талаптарын орындау үшін ғана шектеулі уақыт сақтауы мүмкін.",
            "**Қайда сақталады.** Бастапқы фотосурет біздің дерекқорда да, бұлттық қоймада да сақталмайды: ол сервердің жедел жадында өңделіп, жасалғаннан кейін бірден жойылады. Cloudflare R2 қоймасында тек нәтиже сақталады; дерекқорда — техникалық жазба (пайдаланушы идентификаторы, тауар, нәтижеге сілтеме, күні).",
            "**Сақтау мерзімі.** Нәтиже сіз оны өзіңіз жойғанға дейін немесе аккаунтты жойғанға дейін сақталады. Автоматты жою мерзімі жоқ.",
            "**Жою.** Кез келген нәтижені «AI-киіп көру» бөлімінің тарихынан жоюға болады. Аккаунт жойылғанда барлық киіп көрулер бұлттық қоймадағы файлдармен бірге жойылады.",
            "**Пайдалану.** Фотосуреттеріңіз бен нәтижелер біздің немесе үшінші тараптың модельдерін оқыту үшін, жарнама және аналитика үшін пайдаланылмайды.",
            "**Қорғау.** Нәтижелерге тек сіздің авторизацияланған сеансыңыздан қол жеткізуге болады (HttpOnly cookie + серверде иелікті тексеру); деректер HTTPS арқылы беріледі; фотосуреттердің мазмұны сервер журналдарына жазылмайды.",
          ]},
        ],
      },
      {
        h2: "3. Өңдеу мақсаттары",
        blocks: [
          { ul: [
            "Пайдаланушыны тіркеу және аутентификациялау.",
            "VIP адалдық бағдарламасын басқару (бонустарды есептеу мен есептен шығару, деңгейлерді есептеу).",
            "Кеңес алу, өлшеу және ательенің қызметтеріне жазылу.",
            "Жаңалықтар, тапсырыстардың келуі, жеңілдіктер мен акциялар туралы хабарландырулар жіберу.",
            "Туған күнмен құттықтау және сыйлық бонустарын беру.",
            "Қосымша мен ассортиментті жақсарту үшін ішкі талдау.",
            "Алаяқтық пен рұқсатсыз кіруден қорғау.",
          ]},
        ],
      },
      {
        h2: "4. Заңды негіз",
        blocks: [
          { p: "Жеке деректерді өңдеу пайдаланушының нақты келісімі негізінде жүргізіледі, оны ол Қосымшада алғаш тіркелу кезінде (SMS-код алудың алдында тиісті құсбелгі қою арқылы) береді. Келісім кез келген уақытта кері қайтарылуы мүмкін (8-т. қараңыз)." },
        ],
      },
      {
        h2: "5. Сақтау мерзімі",
        blocks: [
          { p: "Деректер пайдаланушының есептік жазбасының бүкіл әрекет ету мерзімі бойы және ол жойылғаннан кейін 5 жыл — Қазақстан Республикасының заңнамасына сәйкес бухгалтерлік және салықтық есеп мақсаттары үшін сақталады. Осы мерзім өткеннен кейін деректер жойылады немесе жасырыналады." },
        ],
      },
      {
        h2: "6. Үшінші тұлғаларға беру",
        blocks: [
          { p: "Оператор жеке деректерді коммерциялық мақсатта үшінші тұлғаларға БЕРМЕЙДІ. Деректер тек Қосымшаның жұмыс істеуі үшін қажет келесі өңдеушілерге беріледі:" },
          { ul: [
            "**SMSC.kz** («СМС-Центр» АҚ, Қазақстан) — растау SMS-кодтарын жеткізу үшін. Тек телефон нөмірі беріледі.",
            "**Google Firebase** (Google LLC, АҚШ) — push-хабарландырулар жіберу үшін. Тек құрылғының жасырын токені беріледі.",
            "**Google Gemini** (Google LLC, АҚШ) — виртуалды өлшеу үшін (пайдаланушының сұрауы бойынша). Сурет өңделеді және сақталмайды.",
            "**ҚР мемлекеттік органдары** — заңнама аясындағы ресми сұрау бойынша.",
          ]},
        ],
      },
      {
        h2: "7. Қорғау шаралары",
        blocks: [
          { ul: [
            "Деректерді беру кезінде шифрлау (HTTPS/TLS).",
            "Әкімшілердің құпиясөздерін bcrypt арқылы хэштеу.",
            "Әкімшілік аккаунттар үшін екі факторлы аутентификация (TOTP).",
            "Ең аз артықшылықтар қағидаты бойынша қызметкерлердің қолжетімділігін шектеу.",
            "Әкімшілердің әрекеттерін журналдау (аудит-лог).",
            "Дерекқорларды тұрақты сақтық көшірмелеу.",
          ]},
        ],
      },
      {
        h2: "8. Пайдаланушының құқықтары",
        blocks: [
          { p: "ҚР «Жеке деректер және оларды қорғау туралы» Заңына сәйкес сізде мынадай құқық бар:" },
          { ul: [
            "Бізде сіздің жеке деректеріңіздің бар-жоғы туралы ақпарат алу.",
            "Деректер дұрыс емес немесе толық болмаса, оларды түзетуді немесе толықтыруды сұрау.",
            "Деректер заң бұзушылықпен өңделсе, оларды блоктауды немесе жоюды сұрау.",
            "Жеке деректерді өңдеуге келісімді кез келген уақытта қайтарып алу.",
            "ҚР Сауда және интеграция министрлігінің Тұтынушылардың құқықтарын қорғау комитетіне шағыммен жүгіну.",
          ]},
          { p: "Осы құқықтарды жүзеге асыру үшін [angiolinikz@gmail.com](mailto:angiolinikz@gmail.com) мекенжайына «Жеке деректер» тақырыбымен сұрау жіберіңіз — біз 15 жұмыс күні ішінде жауап береміз." },
        ],
      },
      {
        h2: "9. Саясаттағы өзгерістер",
        blocks: [
          { p: "Оператор Құпиялылық саясатын мезгіл-мезгіл жаңарту құқығын өзіне қалдырады. Елеулі өзгерістер туралы пайдаланушыларға push-хабарландыру немесе Қосымшаның ішінде өзгерістер күшіне енгенге дейін кемінде 7 күн бұрын хабарланады." },
        ],
      },
      {
        h2: "10. Байланыс мәліметтері",
        blocks: [
          { p: "«Italy Retail» ЖШС\nБСН 220540021868\nМекенжайы: Алматы қ., Әл-Фараби к-сі 5/2, «Jurek Tau» СО, -1 қабат\nEmail: [angiolinikz@gmail.com](mailto:angiolinikz@gmail.com)\nТел.: [+7 701 801 77 55](tel:+77018017755)" },
        ],
      },
    ],
  },

  en: {
    effective: "Effective date: January 1, 2026.",
    sections: [
      {
        h2: "1. General Provisions",
        blocks: [
          { p: "This Privacy Policy defines the procedure for processing personal data of users of the Angiolini VIP Club mobile application and website (hereinafter — the “App”), whose operator is Italy Retail LLP, BIN 220540021868, Almaty, 5/2 Al-Farabi St., Jurek Tau Mall, -1 floor (hereinafter — the “Operator”, “we”)." },
          { p: "The Policy is developed in accordance with the Law of the Republic of Kazakhstan No. 94-V dated 21.05.2013 “On Personal Data and Its Protection”." },
        ],
      },
      {
        h2: "2. What Data We Collect",
        blocks: [
          { ul: [
            "**Phone number** — for registration and login via SMS code.",
            "**Name** — for addressing the client in communication and bookings.",
            "**Date of birth** — for birthday bonus crediting.",
            "**City** — for assortment selection and delivery points.",
            "**Purchase history** — to calculate VIP tier, cashback and personalised offers.",
            "**Consultation & fitting bookings** — to coordinate time with the manager.",
            "**Referral code** and link with the inviter — to credit referral bonuses.",
            "**Photos for virtual try-on** — processed by an AI model and NOT stored on the server after the result is generated (unless the user explicitly requests otherwise).",
            "**Device push tokens** (Firebase) — to send notifications about new arrivals and bookings.",
            "**IP address and device type** — for security and abuse prevention.",
          ]},
        ],
      },
      {
        h2: "2.1. Photos for AI Try-On (images that may contain a face)",
        blocks: [
          { p: "The virtual try-on runs only when you initiate it: you choose the photo yourself and give a separate, explicit consent before the photo is transmitted. Without that consent no photo is sent and no try-on is generated." },
          { ul: [
            "**What is collected.** The photo you upload (it may contain your face) and the generated try-on image.",
            "**What is NOT performed.** We do not perform face recognition, do not extract face landmarks, do not create or store biometric templates, do not identify individuals and do not match photos between users. The photo is used solely as a visual reference to render the garment on you.",
            "**Who receives it.** The photo is transmitted over a secure channel to the Google Gemini API (model gemini-3.1-flash-image-preview) through the Emergent Integrations LLM proxy, for the sole purpose of generating the try-on image. Under the Gemini API terms for paid services, submitted data is not used to train Google's models; Google may log requests for a limited period solely for abuse monitoring and legal compliance.",
            "**Where it is stored.** The original photo is never stored in our database or object storage: it is processed in server memory and discarded immediately after generation. Only the generated result is stored in Cloudflare R2, together with a technical record in our database (user id, product, result link, timestamp).",
            "**Retention.** A generated result is kept until you delete it or delete your account. There is no automatic deletion period for results.",
            "**Deletion.** Any result can be deleted in the AI Try-On section (history). Deleting your account removes all your try-on results together with the files in object storage.",
            "**Use.** Your photos and results are never used to train our or third-party models, for advertising or for analytics, and are not published in marketing materials.",
            "**Safeguards.** Results are accessible only from your authenticated session (HttpOnly cookie plus server-side ownership check); data is transmitted over HTTPS; photo content is never written to server logs (logs contain only file size and processing time).",
          ]},
        ],
      },
      {
        h2: "3. Purposes of Processing",
        blocks: [
          { ul: [
            "User registration and authentication.",
            "Managing the VIP loyalty program (crediting and debiting bonuses, calculating tiers).",
            "Booking consultations, fittings and atelier services.",
            "Sending notifications about new arrivals, order status, discounts and promotions.",
            "Birthday greetings and gift bonuses.",
            "Internal analytics to improve the App and assortment.",
            "Protection against fraud and unauthorised access.",
          ]},
        ],
      },
      {
        h2: "4. Legal Basis",
        blocks: [
          { p: "Personal data is processed with the user's explicit consent given upon first registration in the App (by ticking the corresponding checkbox before receiving the SMS code). Consent may be withdrawn at any time (see section 8)." },
        ],
      },
      {
        h2: "5. Retention Period",
        blocks: [
          { p: "Data is stored for the entire duration of the user account and for 5 years after its deletion — for accounting and tax purposes in accordance with the legislation of the Republic of Kazakhstan. After this period, the data is deleted or anonymised." },
        ],
      },
      {
        h2: "6. Transfer to Third Parties",
        blocks: [
          { p: "The Operator does NOT transfer personal data to third parties for commercial purposes. Data is transferred only to the following processors required for the operation of the App:" },
          { ul: [
            "**SMSC.kz** (SMS-Center JSC, Kazakhstan) — for delivering confirmation SMS codes. Only the phone number is transmitted.",
            "**Google Firebase** (Google LLC, USA) — for sending push notifications. Only an anonymised device token is transmitted.",
            "**Google Gemini** (Google LLC, USA) — for virtual try-on (upon user request). Image is processed and not stored.",
            "**Government authorities of the Republic of Kazakhstan** — upon official request within the framework of the legislation.",
          ]},
        ],
      },
      {
        h2: "7. Protection Measures",
        blocks: [
          { ul: [
            "Data encryption in transit (HTTPS/TLS).",
            "Hashing of admin passwords using bcrypt.",
            "Two-factor authentication (TOTP) for admin accounts.",
            "Employee access restriction based on the principle of least privilege.",
            "Admin action logging (audit log).",
            "Regular database backups.",
          ]},
        ],
      },
      {
        h2: "8. User Rights",
        blocks: [
          { p: "In accordance with the Law of the Republic of Kazakhstan “On Personal Data and Its Protection”, you have the right to:" },
          { ul: [
            "Receive information about whether we hold your personal data.",
            "Request correction or completion of data if it is inaccurate or incomplete.",
            "Request blocking or deletion of data if it is processed in violation of the law.",
            "Withdraw consent for the processing of personal data at any time.",
            "File a complaint with the Committee for Consumer Rights Protection of the Ministry of Trade and Integration of the Republic of Kazakhstan.",
          ]},
          { p: "To exercise these rights, send a request to [angiolinikz@gmail.com](mailto:angiolinikz@gmail.com) with the subject “Personal Data” — we will respond within 15 business days." },
        ],
      },
      {
        h2: "9. Policy Changes",
        blocks: [
          { p: "The Operator reserves the right to periodically update this Privacy Policy. Users will be notified of material changes via push notification or inside the App no later than 7 days before the changes take effect." },
        ],
      },
      {
        h2: "10. Contact for Inquiries",
        blocks: [
          { p: "Italy Retail LLP\nBIN 220540021868\nAddress: Almaty, 5/2 Al-Farabi St., Jurek Tau Mall, -1 floor\nEmail: [angiolinikz@gmail.com](mailto:angiolinikz@gmail.com)\nPhone: [+7 701 801 77 55](tel:+77018017755)" },
        ],
      },
    ],
  },
};

/* ────────────────────────────── LOYALTY TERMS ────────────────────────────── */
const terms = {
  ru: {
    effective: "Действует с 1 января 2026 г.",
    sections: [
      {
        h2: "1. Общие положения",
        blocks: [
          { p: "Настоящие Условия регулируют участие в программе лояльности «Angiolini VIP Club» (далее — «Программа»), которую проводит ТОО «Italy Retail» (БИН 220540021868) для своих клиентов." },
          { p: "Участником Программы становится любой клиент, зарегистрировавшийся в мобильном приложении или веб-приложении Angiolini VIP Club по номеру телефона." },
        ],
      },
      {
        h2: "2. Бонусные баллы",
        blocks: [
          { ul: [
            "**1 бонус = 1 тенге** — бонусы можно использовать для оплаты товаров и услуг бутика.",
            "Бонусы НЕ конвертируются в наличные и НЕ передаются другим клиентам.",
            "Бонусы НЕ начисляются на стоимость, оплаченную самими бонусами.",
          ]},
        ],
      },
      {
        h2: "3. Начисление бонусов",
        blocks: [
          { ul: [
            "**10 000 ₸** — приветственный бонус за регистрацию в приложении (зачисляется однократно).",
            "**5 000 ₸** — бонус за каждого приглашённого друга по реферальной ссылке, после его первой покупки.",
          ]},
          { p: "**Кэшбэк** с каждой покупки по VIP-уровню клиента:" },
          { ulNested: [
            "Silver (до 1 000 000 ₸ покупок) — 1%",
            "Gold (от 1 000 000 ₸) — 2%",
            "Platinum (от 5 000 000 ₸) — 3%",
            "Diamond (от 15 000 000 ₸) — 4%",
          ]},
          { p: "**Бонус в День рождения — 50 000 ₸** (начисляется ежегодно). Зачисляется **за 7 дней до** вашего дня рождения и сгорает **через 7 дней после**. У вас есть **14 дней**, чтобы порадовать себя — потратьте бонус на любую покупку или примерку в бутике." },
        ],
      },
      {
        h2: "4. Период разблокировки",
        blocks: [
          { p: "Кэшбэк-бонусы становятся доступными для списания **через 15 дней** после покупки. Это связано с правом клиента на возврат товара в соответствии с законодательством РК. До истечения 15 дней бонусы отображаются в личном кабинете как «заблокированные»." },
        ],
      },
      {
        h2: "5. Использование бонусов",
        blocks: [
          { ul: [
            "Бонусами можно оплатить **не более 20% от стоимости товара** (например, при покупке на 500 000 ₸ можно списать максимум 100 000 бонусов).",
            "При использовании бонусов скидка применяется к каждой позиции отдельно.",
            "Списание бонусов производится в бутике при оплате либо в приложении при оформлении заказа.",
          ]},
        ],
      },
      {
        h2: "6. Срок действия бонусов",
        blocks: [
          { p: "Каждый бонус действует **12 месяцев** с момента начисления. По истечении этого срока неиспользованные бонусы аннулируются автоматически. Клиент уведомляется о приближающемся истечении срока через push-уведомление за 30 и 7 дней." },
        ],
      },
      {
        h2: "7. Возвраты и аннулирование бонусов",
        blocks: [
          { ul: [
            "При возврате товара бонусы, начисленные за эту покупку, списываются со счёта клиента.",
            "Если бонусы уже были использованы, недостающая сумма удерживается из возвращаемых средств.",
            "Бонусы, начисленные с нарушением Программы (например, мошенничество), могут быть аннулированы Оператором с уведомлением клиента.",
          ]},
        ],
      },
      {
        h2: "8. VIP-уровни",
        blocks: [
          { p: "VIP-уровень рассчитывается на основе общей суммы покупок за всё время участия в Программе. Уровень повышается автоматически и не может быть понижен. Каждый уровень предоставляет:" },
          { ul: [
            "**Silver** (до 1 000 000 ₸) — приветственный бонус, кэшбэк 1%, доступ к каталогу.",
            "**Gold** (от 1 000 000 ₸) — всё из Silver + приоритетная запись, кэшбэк 2%.",
            "**Platinum** (от 5 000 000 ₸) — всё из Gold + персональный стилист, кэшбэк 3%, ранний доступ к коллекциям.",
            "**Diamond** (от 15 000 000 ₸) — всё из Platinum + индивидуальные предложения, кэшбэк 4%, VIP-обслуживание.",
          ]},
        ],
      },
      {
        h2: "9. Изменения условий",
        blocks: [
          { p: "Оператор вправе изменять условия Программы. Существенные изменения (изменение размера кэшбэка, срока действия бонусов, правил списания) вступают в силу через 30 дней после уведомления участников." },
        ],
      },
      {
        h2: "10. Прекращение участия",
        blocks: [
          { p: "Клиент может в любой момент удалить свой аккаунт через личный кабинет или отправив запрос на [angiolinikz@gmail.com](mailto:angiolinikz@gmail.com). При удалении аккаунта все накопленные бонусы аннулируются и не подлежат восстановлению." },
        ],
      },
      {
        h2: "11. Спорные ситуации",
        blocks: [
          { p: "Все споры решаются путём переговоров. При невозможности достижения согласия — в порядке, установленном законодательством Республики Казахстан, по месту нахождения Оператора (г. Алматы)." },
        ],
      },
    ],
  },

  kz: {
    effective: "2026 жылғы 1 қаңтардан бастап қолданылады.",
    sections: [
      {
        h2: "1. Жалпы ережелер",
        blocks: [
          { p: "Осы Шарттар «Angiolini VIP Club» адалдық бағдарламасына (бұдан әрі — «Бағдарлама») қатысуды реттейді. Бағдарламаны өз клиенттеріне «Italy Retail» ЖШС (БСН 220540021868) жүргізеді." },
          { p: "Бағдарламаға қатысушы — телефон нөмірі бойынша Angiolini VIP Club мобильді немесе веб-қосымшасында тіркелген кез келген клиент." },
        ],
      },
      {
        h2: "2. Бонустар",
        blocks: [
          { ul: [
            "**1 бонус = 1 теңге** — бонустарды бутиктің тауарлары мен қызметтерін төлеу үшін пайдалануға болады.",
            "Бонустарды қолма-қол ақшаға АУДАРУҒА БОЛМАЙДЫ және басқа клиенттерге БЕРУГЕ БОЛМАЙДЫ.",
            "Бонустармен төленген сомаға бонустар ЕСЕПТЕЛМЕЙДІ.",
          ]},
        ],
      },
      {
        h2: "3. Бонустарды есептеу",
        blocks: [
          { ul: [
            "**10 000 ₸** — қосымшада тіркелгені үшін сәлемдесу бонусы (бір рет есептеледі).",
            "**5 000 ₸** — рефералдық сілтеме арқылы шақырылған әрбір досыңыз үшін оның алғашқы сатып алуынан кейін.",
          ]},
          { p: "Клиенттің VIP-деңгейі бойынша әрбір сатып алудан **Кэшбэк**:" },
          { ulNested: [
            "Silver (1 000 000 ₸-ге дейінгі сатып алулар) — 1%",
            "Gold (1 000 000 ₸-ден бастап) — 2%",
            "Platinum (5 000 000 ₸-ден бастап) — 3%",
            "Diamond (15 000 000 ₸-ден бастап) — 4%",
          ]},
          { p: "**Туған күн бонусы — 50 000 ₸** (жыл сайын есептеледі). Туған күніңізге **7 күн қалғанда** есептеледі және **7 күн өткеннен кейін** жойылады. Өзіңізді қуантуға **14 күн** беріледі — бонусты бутикте кез келген сатып алуға немесе өлшеуге жұмсаңыз." },
        ],
      },
      {
        h2: "4. Ашылу мерзімі",
        blocks: [
          { p: "Кэшбэк-бонустар сатып алуданкейін **15 күн өткен соң** есептен шығаруға қолжетімді болады. Бұл ҚР заңнамасына сәйкес клиенттің тауарды қайтару құқығына байланысты. 15 күн өткенге дейін бонустар жеке кабинетте «блокталған» ретінде көрсетіледі." },
        ],
      },
      {
        h2: "5. Бонустарды пайдалану",
        blocks: [
          { ul: [
            "Бонустармен тауар құнының **20%-нан аспайтын** бөлігін төлеуге болады (мысалы, 500 000 ₸-ге сатып алуда ең көбі 100 000 бонус есептен шығаруға болады).",
            "Бонустарды пайдалану кезінде жеңілдік әрбір позицияға бөлек қолданылады.",
            "Бонустарды есептен шығару бутикте төлеу кезінде немесе қосымшада тапсырыс рәсімдеу кезінде жүргізіледі.",
          ]},
        ],
      },
      {
        h2: "6. Бонустардың әрекет ету мерзімі",
        blocks: [
          { p: "Әрбір бонус есептелген сәттен бастап **12 ай** әрекет етеді. Осы мерзім өткеннен кейін пайдаланылмаған бонустар автоматты түрде жойылады. Клиентке мерзімнің жақындауы туралы 30 және 7 күн бұрын push-хабарландыру арқылы хабарланады." },
        ],
      },
      {
        h2: "7. Қайтарулар және бонустарды жою",
        blocks: [
          { ul: [
            "Тауарды қайтарған кезде осы сатып алуға есептелген бонустар клиенттің есебінен алынады.",
            "Егер бонустар пайдаланылып қойса, жетіспейтін сома қайтарылатын қаражаттан ұсталады.",
            "Бағдарламаны бұзу арқылы (мысалы, алаяқтық) есептелген бонустарды Оператор клиентке хабарлай отырып жоюы мүмкін.",
          ]},
        ],
      },
      {
        h2: "8. VIP-деңгейлер",
        blocks: [
          { p: "VIP-деңгей Бағдарламаға қатысудың барлық уақытындағы сатып алулардың жалпы сомасы негізінде есептеледі. Деңгей автоматты түрде көтеріледі және төмендетілмейді. Әрбір деңгей:" },
          { ul: [
            "**Silver** (1 000 000 ₸-ге дейін) — сәлемдесу бонусы, 1% кэшбэк, каталогқа қолжетімділік.",
            "**Gold** (1 000 000 ₸-ден бастап) — Silver-дегінің бәрі + басым жазба, 2% кэшбэк.",
            "**Platinum** (5 000 000 ₸-ден бастап) — Gold-тағының бәрі + жеке стилист, 3% кэшбэк, коллекцияларға ерте қолжетімділік.",
            "**Diamond** (15 000 000 ₸-ден бастап) — Platinum-дағының бәрі + жеке ұсыныстар, 4% кэшбэк, VIP-қызмет.",
          ]},
        ],
      },
      {
        h2: "9. Шарттардағы өзгерістер",
        blocks: [
          { p: "Оператор Бағдарлама шарттарын өзгертуге құқылы. Елеулі өзгерістер (кэшбэк мөлшері, бонустардың мерзімі, есептен шығару ережелерінің өзгеруі) қатысушыларға хабарлағаннан кейін 30 күн өткен соң күшіне енеді." },
        ],
      },
      {
        h2: "10. Қатысуды тоқтату",
        blocks: [
          { p: "Клиент кез келген уақытта жеке кабинет арқылы немесе [angiolinikz@gmail.com](mailto:angiolinikz@gmail.com) мекенжайына сұрау жіберу арқылы аккаунтын жоя алады. Аккаунт жойылған кезде жинақталған барлық бонустар жойылады және қалпына келтірілмейді." },
        ],
      },
      {
        h2: "11. Дау-жанжалдар",
        blocks: [
          { p: "Барлық даулар келіссөздер жолымен шешіледі. Келісімге қол жеткізу мүмкін болмаған жағдайда — Оператордың орналасқан жері (Алматы қ.) бойынша Қазақстан Республикасының заңнамасында белгіленген тәртіппен шешіледі." },
        ],
      },
    ],
  },

  en: {
    effective: "In effect from January 1, 2026.",
    sections: [
      {
        h2: "1. General Provisions",
        blocks: [
          { p: "These Terms govern participation in the Angiolini VIP Club loyalty program (hereinafter — the “Program”), operated by Italy Retail LLP (BIN 220540021868) for its clients." },
          { p: "Any client who registers in the Angiolini VIP Club mobile or web application by phone number becomes a Participant of the Program." },
        ],
      },
      {
        h2: "2. Bonus Points",
        blocks: [
          { ul: [
            "**1 bonus = 1 tenge** — bonuses can be used to pay for the boutique's goods and services.",
            "Bonuses are NOT convertible to cash and CANNOT be transferred to other clients.",
            "Bonuses are NOT accrued on the amount paid with bonuses.",
          ]},
        ],
      },
      {
        h2: "3. Bonus Accrual",
        blocks: [
          { ul: [
            "**10,000 ₸** — welcome bonus for registration in the app (credited once).",
            "**5,000 ₸** — bonus for each friend invited via a referral link, after their first purchase.",
          ]},
          { p: "**Cashback** on every purchase according to the client's VIP tier:" },
          { ulNested: [
            "Silver (up to 1,000,000 ₸ in purchases) — 1%",
            "Gold (from 1,000,000 ₸) — 2%",
            "Platinum (from 5,000,000 ₸) — 3%",
            "Diamond (from 15,000,000 ₸) — 4%",
          ]},
          { p: "**Birthday Bonus — 50,000 ₸** (credited annually). Credited **7 days before** your birthday and expires **7 days after**. You have **14 days** to treat yourself — spend the bonus on any purchase or fitting at the boutique." },
        ],
      },
      {
        h2: "4. Unlock Period",
        blocks: [
          { p: "Cashback bonuses become available for redemption **15 days after** the purchase. This is due to the client's right to return goods in accordance with the legislation of the Republic of Kazakhstan. Until the 15-day period expires, bonuses are displayed in the personal account as “blocked”." },
        ],
      },
      {
        h2: "5. Using Bonuses",
        blocks: [
          { ul: [
            "Bonuses can be used to pay **no more than 20% of the item's price** (e.g., on a 500,000 ₸ purchase you can redeem a maximum of 100,000 bonuses).",
            "When bonuses are used, the discount is applied to each item separately.",
            "Bonuses are redeemed at the boutique during payment or in the app during checkout.",
          ]},
        ],
      },
      {
        h2: "6. Bonus Validity",
        blocks: [
          { p: "Each bonus is valid for **12 months** from the moment of accrual. After this period, unused bonuses are automatically cancelled. The client is notified of the approaching expiration via push notification 30 and 7 days in advance." },
        ],
      },
      {
        h2: "7. Returns and Bonus Cancellation",
        blocks: [
          { ul: [
            "When returning an item, bonuses credited for this purchase are debited from the client's account.",
            "If bonuses have already been used, the missing amount is withheld from the refund.",
            "Bonuses credited in violation of the Program (e.g., fraud) may be cancelled by the Operator with client notification.",
          ]},
        ],
      },
      {
        h2: "8. VIP Tiers",
        blocks: [
          { p: "The VIP tier is calculated based on the total purchase amount over the entire period of participation in the Program. The tier increases automatically and cannot be downgraded. Each tier provides:" },
          { ul: [
            "**Silver** (up to 1,000,000 ₸) — welcome bonus, 1% cashback, catalog access.",
            "**Gold** (from 1,000,000 ₸) — all of Silver + priority booking, 2% cashback.",
            "**Platinum** (from 5,000,000 ₸) — all of Gold + personal stylist, 3% cashback, early access to collections.",
            "**Diamond** (from 15,000,000 ₸) — all of Platinum + individual offers, 4% cashback, VIP service.",
          ]},
        ],
      },
      {
        h2: "9. Changes to the Terms",
        blocks: [
          { p: "The Operator is entitled to change the terms of the Program. Material changes (changes in the cashback amount, bonus validity period, redemption rules) take effect 30 days after notifying participants." },
        ],
      },
      {
        h2: "10. Termination of Participation",
        blocks: [
          { p: "The client may delete their account at any time via their personal account or by sending a request to [angiolinikz@gmail.com](mailto:angiolinikz@gmail.com). Upon account deletion, all accumulated bonuses are cancelled and cannot be restored." },
        ],
      },
      {
        h2: "11. Disputes",
        blocks: [
          { p: "All disputes are resolved through negotiations. If no agreement is reached — in accordance with the procedure established by the legislation of the Republic of Kazakhstan, at the location of the Operator (Almaty)." },
        ],
      },
    ],
  },
};

export const legalContent = {
  ru: { privacy: privacy.ru, terms: terms.ru },
  kz: { privacy: privacy.kz, terms: terms.kz },
  en: { privacy: privacy.en, terms: terms.en },
};
